import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TFeatureFlags } from '../api-ducks/feature-flags-duck/types-feature-flags';

const initialState: TFeatureFlags | null = null;

const featureFlagsDuck = createSlice({
  name: 'appConfig',
  initialState: initialState as TFeatureFlags | null,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<TFeatureFlags>) => action.payload,
  },
});

export const { setFeatureFlags } = featureFlagsDuck.actions;
export default featureFlagsDuck.reducer;
